var _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9085 1.14731C4.25988 1.50519 4.25988 2.08542 3.9085 2.44329C1.09655 5.30723 1.09655 9.95061 3.9085 12.8145C4.25988 13.1724 4.25988 13.7527 3.9085 14.1105C3.55712 14.4684 2.98742 14.4684 2.63604 14.1105C-0.87868 10.5308 -0.87868 4.727 2.63604 1.14731C2.98742 0.789438 3.55712 0.789438 3.9085 1.14731ZM15.3639 1.14731C18.8787 4.727 18.8787 10.5308 15.3639 14.1105C15.0126 14.4684 14.4429 14.4684 14.0915 14.1105C13.7401 13.7527 13.7401 13.1724 14.0915 12.8145C16.9034 9.95061 16.9034 5.30723 14.0915 2.44329C13.7401 2.08542 13.7401 1.50519 14.0915 1.14731C14.4429 0.789438 15.0126 0.789438 15.3639 1.14731ZM6.5778 3.78047C6.92918 4.13835 6.92918 4.71858 6.5778 5.07646C5.20029 6.47947 5.20029 8.75407 6.5778 10.1571C6.92918 10.5149 6.92918 11.0952 6.5778 11.453C6.22642 11.8109 5.65672 11.8109 5.30534 11.453C3.22506 9.33433 3.22506 5.89921 5.30534 3.78047C5.65672 3.42259 6.22642 3.42259 6.5778 3.78047ZM12.8386 3.78047C14.919 5.89921 14.919 9.33433 12.8386 11.453C12.4873 11.8109 11.9176 11.8109 11.5662 11.453C11.2148 11.0952 11.2148 10.5149 11.5662 10.1571C12.9437 8.75407 12.9437 6.47947 11.5662 5.07646C11.2148 4.71858 11.2148 4.13835 11.5662 3.78047C11.9176 3.42259 12.4873 3.42259 12.8386 3.78047ZM9.07202 6.31837C9.81739 6.31837 10.4217 6.93382 10.4217 7.69297C10.4217 8.45211 9.81739 9.06757 9.07202 9.06757C8.32665 9.06757 7.72237 8.45211 7.72237 7.69297C7.72237 6.93382 8.32665 6.31837 9.07202 6.31837Z",
    fill: "#0D0D0D"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.2577,
    cy: 7.7098,
    rx: 1.54286,
    ry: 1.57137,
    fill: "#F75666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveIcon);
export default __webpack_public_path__ + "static/media/liveIcon.27311c1fc9cc934c01aa0d77089e48d2.svg";
export { ForwardRef as ReactComponent };